import { Button } from 'antd';
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalContainer = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 90vh;
  overflow-y: scroll;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ModalTitle = styled.h4`
  font-size: 1.5rem;
  color: #333;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;

export const ModalBody = styled.div``;

export const InputField = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export const SelectField = styled.select`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  appearance: none;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  background-color: #40a0fb;
  color: white;
  border: none;
  padding: 10px 0;
  height: 40px;
  cursor: pointer;
  outline: none;
  &:hover {
    background-color: #0056b3;
  }
`;

export const NextPageButton = styled.button`
  width: 100%;
  background-color: #40a0fb;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  &:hover {
    background-color: #0056b3;
  }
`;

export const StepsBox = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0;
  width: auto;
`;
